type TranslationRecord = {
  type: string;
  locale: string;
  url: string;
  title: string;
  body: string;
};

// In case of change, these constants have to be synchronized with Service Worker implementation (wfm-sw.js).
export const WFM_INDEXED_DB = {
  name: 'wfm-indexed-db',
  version: 2,
} as const;

export const WFM_LOCALIZATION_OBJECT_STORE = {
  name: 'wfm-localization-object-store',
  keyPath: 'type',
} as const;

/**
 * Initialize
 */
export const initializeServiceWorkerLocalization = (translations: TranslationRecord[]) => {
  if (!('indexedDB' in window)) {
    // eslint-disable-next-line no-console
    console.warn("[initializeServiceWorkerLocalization]: This browser doesn't support IndexedDB!");
    return;
  }

  try {
    const openRequest = window.indexedDB.open(WFM_INDEXED_DB.name, WFM_INDEXED_DB.version);

    /**
     * In case of version change this event serves for initialization of DB.
     * Also this event is triggered if the client had no database (new DB is created).
     */
    openRequest.onupgradeneeded = (event) => {
      const db = openRequest.result;

      db.onerror = (e) => {
        // eslint-disable-next-line no-console
        console.warn('[initializeServiceWorkerLocalization]: Failed to perform upgrade.', e);
      };

      // Update from old version to new version accordingly. New users do not need to have any DB created yet.
      if (event.oldVersion < 2) {
        if (db.objectStoreNames.contains(WFM_LOCALIZATION_OBJECT_STORE.name)) {
          db.deleteObjectStore(WFM_LOCALIZATION_OBJECT_STORE.name);
        }

        db.createObjectStore(WFM_LOCALIZATION_OBJECT_STORE.name, {
          keyPath: WFM_LOCALIZATION_OBJECT_STORE.keyPath,
        });
      }
    };

    openRequest.onerror = () => {
      // eslint-disable-next-line no-console
      console.warn('[initializeServiceWorkerLocalization]: Failed to open indexed DB with error:', openRequest.error);
    };

    openRequest.onsuccess = () => {
      const db = openRequest.result;

      db.onerror = (e) => {
        // eslint-disable-next-line no-console
        console.warn('[initializeServiceWorkerLocalization]: Error occurred during localization save.', e);
      };

      const transaction = db.transaction(WFM_LOCALIZATION_OBJECT_STORE.name, 'readwrite');
      const objectStore = transaction.objectStore(WFM_LOCALIZATION_OBJECT_STORE.name);

      // create or update
      translations.forEach((record) => {
        const request = objectStore.put(record);

        request.onerror = (e) => {
          // eslint-disable-next-line no-console
          console.warn('[initializeServiceWorkerLocalization]: Failed to save localization:', translations);
          // eslint-disable-next-line no-console
          console.warn('[initializeServiceWorkerLocalization]: Cause:', e);
        };
      });

      transaction.oncomplete = () => {
        db.close();
      };
    };
  } catch (e) {
    console.error(e);
    // NOOP
  }
};
